// @ts-nocheck
import Vue from "vue";
import Component from "vue-class-component";

import * as Recorder from "recorder-core/recorder.mp3.min";
import "recorder-core/src/extensions/waveview";
import { Ref } from "vue-property-decorator";
// import * as Recorder from "recorder-core";
// import "recorder-core/src/engine/mp3";
// import "recorder-core/src/engine/mp3-engine";

@Component
export default class VoiceRecorderMixin extends Vue {
  public rec;
  public rec_wave;
  public recInfo = null;
  public voiceBlob = null;
  public recordPaused = true;

  @Ref("wave") readonly wave;

  /**
   * 请求录音权限
   */
  async requestPermission(success, refused, errorHandler) {
    this.rec = Recorder({
      type: "mp3",
      sampleRate: 16000,
      bitRate: 16,
      onProcess: (
        buffers,
        powerLevel,
        bufferDuration,
        bufferSampleRate,
        newBufferIds,
        asyncEnd
      ) => {
        this.recInfo = {
          buffers,
          powerLevel,
          bufferDuration,
          bufferSampleRate,
          newBufferIds,
        };
        if (this.wave && this.rec_wave) {
          this.rec_wave.input(
            buffers[buffers.length - 1],
            powerLevel,
            bufferSampleRate
          );
        }
      },
    });

    this.rec.open(
      () => {
        if (this.wave) {
          const newWave = document.createElement("div");
          newWave.setAttribute("id", "nmsl-wave");
          newWave.setAttribute("style", "width: 430px;height: 60px");
          this.wave.appendChild(newWave);
          this.rec_wave = Recorder.WaveView({
            elem: newWave,
          });
        }
        success && success();
      },
      (msg, isUserNotAllow) => {
        if (isUserNotAllow) refused && refused();
        else errorHandler && errorHandler(msg);
        this.rec = null;
      }
    );
  }

  /**
   * 开始录音
   */
  async startRecord() {
    this.recInfo = null;
    this.voiceBlob = null;
    this.recordPaused = false;
    this.rec.start();
  }

  /**
   * 结束录音
   */
  stopRecord() {
    return new Promise((resolve) => {
      this.rec.stop(
        (blob, duration) => {
          console.log(
            blob,
            (window.URL || webkitURL).createObjectURL(blob),
            "时长:" + duration + "ms"
          );
          this.rec.close();
          this.rec = null;
          this.recInfo = null;
          this.voiceBlob = blob;
          resolve(blob);
        },
        (msg) => {
          console.log("录音失败", msg);
          this.rec.close();
          this.rec = null;
          this.recInfo = null;
        }
      );
    });
  }

  async pauseRecord() {
    if (this.rec) {
      this.recordPaused = true;
      this.rec.pause();
    }
  }

  async resumeRecord() {
    if (this.rec) {
      this.recordPaused = false;
      this.rec.resume();
    }
  }
}
